import React, { useEffect, useState } from "react";
import { ResponseInterface } from "../../../interfaces/ResponseInterface";
import QLoading from "../../../common/components/QLoading";
import { BusinessInterface } from "../../../interfaces/private/BusinessInterface";
import BusinessApi from "../../../common/api/functions/Business";
import QModal from "../../../common/components/QModal";
import BodyIntegrateComponent from "./components/BodyIntegrateComponent";
import { config } from "../../../config";
import { AccountInterface } from "../../../interfaces/private/AccountInterface";
import BodyAccountComponent from "./components/ChangePassword";
import {useTranslation} from "react-i18next";
import SettingsPageHeader from "../Settings/components/SettingsPageHeader";
import SettingsPanelCard from "../Settings/components/SettingsPanelCard";
import {getSyncEngineVersion} from "../../../common/helpers/syncEngine";

export function Business() {
    const { t } = useTranslation();
    const isV2 = getSyncEngineVersion() === "v2";
    const [business, setBusiness] = useState<BusinessInterface>({
        address: undefined,
        city: undefined,
        company_name: undefined,
        country: undefined,
        created_at: undefined,
        cvr_no: undefined,
        email: undefined,
        id: undefined,
        name: undefined,
        phone: undefined,
        updated_at: undefined,
        website: undefined,
        zip: undefined,
        password: undefined
    });

    const [account, setAccount] = useState<AccountInterface>({
        current_password: undefined,
        new_password: undefined,
        new_password_confirm: undefined
    });
    const [loading, setLoading] = useState(true);
    const [createNewClick, setCreateNewClick] = useState(false);
    const [updateNewClick, setUpdateNewClick] = useState(false);

    useEffect(() => {
        if (loading) {
            loadBusiness().then(async () => {
                await setLoading(false);
            });
        }
    }, [loading]);

    const loadBusiness = async () => {
        try {
            await BusinessApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setBusiness(
                        response?.data?.data || []
                    );
                }
            });
        } catch (err) {
            // ignore
        }
        if (loading) {
            await setLoading(false);
        }
    };

    const profileComplete = Boolean(business.email && (business.company_name || business.name));
    const displayName = business.name || business.company_name || t("business.profileIncomplete");

    return (
        <React.Fragment>
            <QModal
                open={createNewClick}
                setOpen={setCreateNewClick}
                headerContent={t("business.title")}
                bodyContent={(
                    <BodyIntegrateComponent
                        model={business}
                        setOpen={setCreateNewClick}
                        setBusiness={setBusiness}
                        setLoadingFunc={setLoading}
                    />
                )}
            />
            <QModal
                open={updateNewClick}
                setOpen={setUpdateNewClick}
                headerContent={t("business.accountInfo")}
                bodyContent={(
                    <BodyAccountComponent
                        model={account}
                        setOpen={setUpdateNewClick}
                        setAccount={setAccount}
                        setLoadingFunc={setLoading}
                    />
                )}
            />
            <QLoading loading={loading} />
            <div className="row">
                <SettingsPageHeader title={t("business.title")} showBackToDashboard={isV2}/>
                <div className="col-lg-12">
                    <SettingsPanelCard
                        title={displayName}
                        badge={{
                            label: profileComplete
                                ? t("business.profileComplete")
                                : t("business.profileIncomplete"),
                            variant: profileComplete ? "success" : "warning",
                        }}
                        help={!profileComplete ? t("business.profileIncompleteHelp") : undefined}
                        onEdit={() => setCreateNewClick(true)}
                        editLabel={t("business.editProfile")}
                        fields={[
                            {label: t("business.cvr"), value: business.cvr_no},
                            {label: t("business.email"), value: business.email},
                            {label: t("business.phone"), value: business.phone},
                            {label: t("business.website"), value: business.website},
                            {
                                label: t("business.detail.address"),
                                value: [business.address, business.city, business.country].filter(Boolean).join(", ") || undefined,
                                fullWidth: true,
                            },
                        ]}
                    />
                    <SettingsPanelCard
                        title={t("business.accountInfo")}
                        help={t("business.accountHelp")}
                        onEdit={() => setUpdateNewClick(true)}
                        editLabel={t("business.changePassword")}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

// @ts-ignore
export default React.memo(Business);
